module.exports = /******/
function(modules) {
    /******/
    /******/
    // The require function
    /******/
    function __webpack_require__(moduleId) {
        /******/
        /******/
        // Check if module is in cache
        /******/
        if (installedModules[moduleId]) /******/
        return installedModules[moduleId].exports;
        /******/
        /******/
        // Create a new module (and put it into the cache)
        /******/
        var module = installedModules[moduleId] = {
            /******/
            exports: {},
            /******/
            id: moduleId,
            /******/
            loaded: !1
        };
        /******/
        /******/
        // Return the exports of the module
        /******/
        /******/
        /******/
        // Execute the module function
        /******/
        /******/
        /******/
        // Flag the module as loaded
        /******/
        return modules[moduleId].call(module.exports, module, module.exports, __webpack_require__), 
        module.loaded = !0, module.exports;
    }
    // webpackBootstrap
    /******/
    // The module cache
    /******/
    var installedModules = {};
    /******/
    /******/
    // Load entry module and return exports
    /******/
    /******/
    /******/
    /******/
    // expose the modules object (__webpack_modules__)
    /******/
    /******/
    /******/
    // expose the module cache
    /******/
    /******/
    /******/
    // __webpack_public_path__
    /******/
    return __webpack_require__.m = modules, __webpack_require__.c = installedModules, 
    __webpack_require__.p = "", __webpack_require__(0);
}([ /* 0 */
/***/
function(module, exports, __webpack_require__) {
    module.exports = __webpack_require__(1);
}, /* 1 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    }), exports.Pagination = exports.default = void 0;
    var _stateless = __webpack_require__(2);
    Object.defineProperty(exports, "Pagination", {
        enumerable: !0,
        get: function() {
            return _interopRequireDefault(_stateless).default;
        }
    });
    var _stateful = __webpack_require__(16), _stateful2 = _interopRequireDefault(_stateful);
    exports.default = _stateful2.default;
}, /* 2 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _toConsumableArray2 = __webpack_require__(3), _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2), _getPrototypeOf = __webpack_require__(4), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(5), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(6), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(7), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(8), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(9), _react2 = _interopRequireDefault(_react), _button = __webpack_require__(10), _button2 = _interopRequireDefault(_button), _props2 = __webpack_require__(11), _styled = __webpack_require__(13), Pagination = function(_PureComponent) {
        function Pagination() {
            var _ref, _temp, _this, _ret;
            (0, _classCallCheck3.default)(this, Pagination);
            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) args[_key] = arguments[_key];
            return _temp = _this = (0, _possibleConstructorReturn3.default)(this, (_ref = Pagination.__proto__ || (0, 
            _getPrototypeOf2.default)(Pagination)).call.apply(_ref, [ this ].concat(args))), 
            _this.onSetPage = function(page) {
                return function() {
                    return _this.props.onSetPage(page);
                };
            }, _ret = _temp, (0, _possibleConstructorReturn3.default)(_this, _ret);
        }
        return (0, _inherits3.default)(Pagination, _PureComponent), (0, _createClass3.default)(Pagination, [ {
            key: "render",
            value: function() {
                var _this2 = this, _props = this.props, total = _props.total, current = _props.current, i18n = _props.i18n, prevLabel = i18n.prev, prevIsDisabled = 1 === current, prevOnClick = this.onSetPage(current - 1), nextLabel = i18n.next, nextIsDisabled = current === total, nextOnClick = this.onSetPage(current + 1);
                return total ? _react2.default.createElement(_styled.Container, null, _react2.default.createElement(_button2.default, {
                    appearance: "link",
                    isDisabled: prevIsDisabled,
                    onClick: prevOnClick
                }, prevLabel), [].concat((0, _toConsumableArray3.default)(Array(total))).map(function(_, i) {
                    var pageNum = i + 1, isDisabled = pageNum === current, Element = isDisabled ? _styled.ButtonActive : _button2.default;
                    return _react2.default.createElement(Element, {
                        isDisabled: isDisabled,
                        key: pageNum,
                        appearance: "link",
                        onClick: _this2.onSetPage(pageNum)
                    }, pageNum);
                }), _react2.default.createElement(_button2.default, {
                    appearance: "link",
                    isDisabled: nextIsDisabled,
                    onClick: nextOnClick
                }, nextLabel)) : null;
            }
        } ]), Pagination;
    }(_react.PureComponent);
    Pagination.propTypes = {
        current: _props2.validateCurrent,
        total: _props2.validateTotal,
        onSetPage: _react.PropTypes.func,
        i18n: _props2.i18nShape
    }, Pagination.defaultProps = {
        current: 1,
        total: 1,
        onSetPage: function() {},
        i18n: _props2.defaultI18n
    }, exports.default = Pagination;
}, /* 3 */
/***/
function(module, exports) {
    module.exports = require("babel-runtime/helpers/toConsumableArray");
}, /* 4 */
/***/
function(module, exports) {
    module.exports = require("babel-runtime/core-js/object/get-prototype-of");
}, /* 5 */
/***/
function(module, exports) {
    module.exports = require("babel-runtime/helpers/classCallCheck");
}, /* 6 */
/***/
function(module, exports) {
    module.exports = require("babel-runtime/helpers/createClass");
}, /* 7 */
/***/
function(module, exports) {
    module.exports = require("babel-runtime/helpers/possibleConstructorReturn");
}, /* 8 */
/***/
function(module, exports) {
    module.exports = require("babel-runtime/helpers/inherits");
}, /* 9 */
/***/
function(module, exports) {
    module.exports = require("react");
}, /* 10 */
/***/
function(module, exports) {
    module.exports = require("@atlaskit/button");
}, /* 11 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function isFinitePositiveInteger(value) {
        return "number" == typeof value && isFinite(value) && Math.floor(value) === value && value >= 0;
    }
    function validateTotal(props, propName, componentName) {
        var value = props[propName];
        if (!isFinitePositiveInteger(value)) {
            var message = "'" + propName + "' should be a positive finite integer, got " + props[propName] + " instead";
            return (0, _utilCommon.createError)(propName, componentName, message);
        }
        return null;
    }
    function validateCurrent(props, propName, componentName) {
        var value = props[propName];
        if (!isFinitePositiveInteger(value)) {
            var message = "'" + propName + "' should be a positive finite integer, got " + props[propName] + " instead";
            return (0, _utilCommon.createError)(propName, componentName, message);
        }
        var total = props.total;
        if (value > total) {
            var _message = "value of '" + propName + "' can't be greater than value of 'total'";
            return (0, _utilCommon.createError)(propName, componentName, _message);
        }
        return null;
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    }), exports.defaultI18n = exports.i18nShape = exports.validateTotal = exports.validateCurrent = void 0;
    var _react = __webpack_require__(9), _utilCommon = __webpack_require__(12);
    validateTotal.isRequired = !1, validateCurrent.isRequired = !1;
    var i18nShape = _react.PropTypes.shape({
        prev: _react.PropTypes.string.isRequired,
        next: _react.PropTypes.string.isRequired
    }), defaultI18n = {
        prev: "Prev",
        next: "Next"
    };
    exports.validateCurrent = validateCurrent, exports.validateTotal = validateTotal, 
    exports.i18nShape = i18nShape, exports.defaultI18n = defaultI18n;
}, /* 12 */
/***/
function(module, exports) {
    module.exports = require("@atlaskit/util-common");
}, /* 13 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    }), exports.ButtonActive = exports.Container = void 0;
    var _taggedTemplateLiteral2 = __webpack_require__(14), _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2), _templateObject = (0, 
    _taggedTemplateLiteral3.default)([ "\n  display: flex;\n  width: 100%;\n" ], [ "\n  display: flex;\n  width: 100%;\n" ]), _templateObject2 = (0, 
    _taggedTemplateLiteral3.default)([ "\n  font-weight: bold;\n  color: #000 !important; /* @todo: until Button supports not faded disabled state */\n" ], [ "\n  font-weight: bold;\n  color: #000 !important; /* @todo: until Button supports not faded disabled state */\n" ]), _styledComponents = __webpack_require__(15), _styledComponents2 = _interopRequireDefault(_styledComponents), _button = __webpack_require__(10), _button2 = _interopRequireDefault(_button);
    exports.Container = _styledComponents2.default.div(_templateObject), exports.ButtonActive = (0, 
    _styledComponents2.default)(_button2.default)(_templateObject2);
}, /* 14 */
/***/
function(module, exports) {
    module.exports = require("babel-runtime/helpers/taggedTemplateLiteral");
}, /* 15 */
/***/
function(module, exports) {
    module.exports = require("styled-components");
}, /* 16 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _getPrototypeOf = __webpack_require__(4), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(5), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(6), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(7), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(8), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(9), _react2 = _interopRequireDefault(_react), _stateless = __webpack_require__(2), _stateless2 = _interopRequireDefault(_stateless), _props = __webpack_require__(11), AkPagination = function(_PureComponent) {
        function AkPagination() {
            var _ref, _temp, _this, _ret;
            (0, _classCallCheck3.default)(this, AkPagination);
            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) args[_key] = arguments[_key];
            return _temp = _this = (0, _possibleConstructorReturn3.default)(this, (_ref = AkPagination.__proto__ || (0, 
            _getPrototypeOf2.default)(AkPagination)).call.apply(_ref, [ this ].concat(args))), 
            _this.state = {
                current: _this.props.defaultCurrent
            }, _this.onSetPage = function(page) {
                _this.props.onSetPage(page), _this.setState({
                    current: page
                });
            }, _ret = _temp, (0, _possibleConstructorReturn3.default)(_this, _ret);
        }
        return (0, _inherits3.default)(AkPagination, _PureComponent), (0, _createClass3.default)(AkPagination, [ {
            key: "componentWillReceiveProps",
            value: function(_ref2) {
                var current = _ref2.current;
                this.state.current !== current && this.setState({
                    current: current
                });
            }
        }, {
            key: "render",
            value: function() {
                return _react2.default.createElement(_stateless2.default, {
                    i18n: this.props.i18n,
                    onSetPage: this.onSetPage,
                    total: this.props.total,
                    current: this.state.current
                });
            }
        } ]), AkPagination;
    }(_react.PureComponent);
    AkPagination.propTypes = {
        defaultCurrent: _props.validateCurrent,
        total: _props.validateTotal,
        onSetPage: _react.PropTypes.func,
        i18n: _props.i18nShape
    }, AkPagination.defaultProps = {
        defaultCurrent: 1,
        total: 1,
        onSetPage: function() {},
        i18n: _props.defaultI18n
    }, exports.default = AkPagination;
} ]);


//////////////////
// WEBPACK FOOTER
// ../pagination/dist/bundle-cjs.js
// module id = 523
// module chunks = 0